import { ROLES } from "../constants/roles";

export const getDefaultOnboardTableType = (effectiveRoles) => {
  if (
    effectiveRoles?.includes(ROLES.ADMIN) ||
    effectiveRoles?.includes(ROLES.DEALER)
  ) {
    return "leads";
  }

  if (effectiveRoles?.includes(ROLES.DRIVER_LEAD_CREATION)) {
    return "leads";
  }

  if (effectiveRoles?.includes(ROLES.DRIVER_LEAD_VIEW)) {
    return "leads";
  }

  return "pre-onboarding";
};
